import i18n from './index'

/**
 * Traduce il nome di una scheda evento zootecnico (animal_custom_form.form_name,
 * vocabolario fisso da DB — vedi docs/todo/I18N_TODO.md) rispettando la lingua
 * corrente. Se il nome non è presente nel vocabolario eventTypeVocab (né lingua
 * corrente né fallback 'it'), ritorna il valore originale così com'è arrivato dal DB.
 * Stesso pattern di cropVocab.js/schemaVocab.js.
 */
export function translateEventTypeName(name) {
  if (!name) return name
  const messages = i18n.global.messages.value
  const locale = i18n.global.locale.value
  const direct = messages[locale]?.eventTypeVocab?.[name]
  if (direct !== undefined) return direct
  const fallback = messages.it?.eventTypeVocab?.[name]
  return fallback !== undefined ? fallback : name
}
